import { AxiosInstance } from 'axios';
import createTimetablesWebApiHttpClient from './createTimetablesWebApiHttpClient';
import { MOMENT_DATE_FORMAT } from '../constants/date_format';
import moment from 'moment';

class EventApi {
    httpClient: AxiosInstance;

    constructor() {
        this.httpClient = createTimetablesWebApiHttpClient();
    }

    async GetEvents(startDate: Date, endDate: Date, campusId?: number, buildingId?: number, managedEventOnly?: boolean, unmatchedManagedEventOnly?: boolean) {
        const formattedStartDate = moment(startDate).format(MOMENT_DATE_FORMAT);
        const formattedEndDate = moment(endDate).format(MOMENT_DATE_FORMAT);
        let url = `/events?startDate=${formattedStartDate}&endDate=${formattedEndDate}`;

        if (buildingId && buildingId !== -1) url += `&buildingId=${buildingId}`;
        if (campusId) url += `&campusId=${campusId}`;
        if (managedEventOnly) url += `&onlyMEvents=true`;
        if (unmatchedManagedEventOnly) url += `&onlyUnmatchedMEvents=true`;
        const { data } = await this.httpClient.get(url);
        return data;

    }

    async PatchEvent(id: number, comment: string) {
        let url = `/events/${id}?comment=${comment}`;

        const { data } = await this.httpClient.patch(url);
        return data;
    }

    async DownloadEventData(startDate?: string, endDate?: string, timeIn?: string, timeOut?: string) {
        let endpoint = `/events/download`;

        if (startDate != null) {
            endpoint = endpoint + `?startDate=${startDate}`;
        }
        if (endDate != null) {
            endpoint = endpoint + `?endDate=${endDate}`;
        }
        if (timeIn != null) {
            endpoint = endpoint + `?timeIn=${timeIn}`;
        }
        if (timeOut != null) {
            endpoint = endpoint + `?timeOut=${timeOut}`;
        }

        const { data } = await this.httpClient.get(endpoint);
        return data;
    }

    async GetItems() {
        const { data } = await this.httpClient.get(`/mevents/items`);
        return data;
    }

    async GetItemsCategories() {
        const { data } = await this.httpClient.get(`/mevents/itemcategories`);
        return data;
    }

    async CreateItem(item: any) {
        const { data } = await this.httpClient.post(`/mevents/item`, item);
        return data;
    }

    async UpdateItem(item: any) {
        const { data } = await this.httpClient.put(`/mevents/item`, item);
        return data;
    }
}

export default EventApi;
